import { HTTP } from './helpers/http.js'

export default {
  add(organizationId, revType, revId, assignees) {
    const url = `api/v1/organizations/${organizationId}/validation-request/${revType}/${revId}`
    return HTTP.post(url, { assignees })
  },

  update(organizationId, revType, revId, requestId, status) {
    const url = `api/v1/organizations/${organizationId}/validation-request/${revType}/${revId}/${requestId}`
    return HTTP.put(url, { status })
  },
}
